import { Button } from '@wix/design-system';
import { ChevronUp } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './BackToTopButton.scss';
export const BackToTopButton = _ref => {
  let forceVisible = _ref.forceVisible;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement("div", {
    className: `${s.wrapper} ${forceVisible ? s.forceVisible : ''}`
  }, /*#__PURE__*/React.createElement(Button, {
    className: s.button,
    size: "medium",
    skin: "dark",
    priority: "secondary",
    suffixIcon: /*#__PURE__*/React.createElement(ChevronUp, null),
    onClick: () => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    }),
    "aria-label": t('domains_search_gate.mobile.floating_button')
  }, t('domains_search_gate.mobile.floating_button')));
};
//# sourceMappingURL=BackToTopButton.js.map